/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type DynamicConfigParameters = { poolCreatorAuthority: Address };

export type DynamicConfigParametersArgs = DynamicConfigParameters;

export function getDynamicConfigParametersEncoder(): FixedSizeEncoder<DynamicConfigParametersArgs> {
  return getStructEncoder([["poolCreatorAuthority", getAddressEncoder()]]);
}

export function getDynamicConfigParametersDecoder(): FixedSizeDecoder<DynamicConfigParameters> {
  return getStructDecoder([["poolCreatorAuthority", getAddressDecoder()]]);
}

export function getDynamicConfigParametersCodec(): FixedSizeCodec<
  DynamicConfigParametersArgs,
  DynamicConfigParameters
> {
  return combineCodec(
    getDynamicConfigParametersEncoder(),
    getDynamicConfigParametersDecoder(),
  );
}
